module.exports = __webpack_public_path__ + "media/ambulance.13db530d.mp3";